import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { DEFAULT_PRODUCT_COMBO } from '../../../Util';
import { get, getDatabase, onValue, ref, update } from 'firebase/database';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useSearchParams } from 'react-router-dom';

interface FormattedData {
  [comboname: string]: {
    status: 'active';
    start: string;
    end: string;
    item: ProductComboItem[];
  };
}
interface ProductCombo2 {
  comboname: string;
  status: string;
  start: string;
  end: string;
  items: ProductComboItem[];
}

interface ProductComboItem {
  sku: string;
  price: string;
}
const formatParamDate = (date: Date) => date.toISOString().slice(0, 10).replaceAll('-', '');
const format = (date: string) => `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
const serialiseSearchParams = (params: any) => {
  return Object.keys(params)
    .map((e) => `${e}=${params[e]}`)
    .join('&');
};
const ComboProduct = () => {
  const db = getDatabase();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDateSelectorClosed, setIsDateSelectorClosed] = useState(true);
  const [productCombo, setProductCombo] = useState<ProductCombo2[]>();
  const start = searchParams.get('from');
  const end = searchParams.get('till');
  const startDate = start ? new Date(format(start)) : new Date();
  const endDate = end ? new Date(format(end)) : new Date();
  const { handleSubmit, control, register, watch } = useForm<ProductCombo2>({
    defaultValues: {
      comboname: '',
      status: 'active',
      start: '',
      end: '',
      items: [
        {
          sku: '',
          price: '',
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });
  useEffect(() => {
    const productComboRef = ref(db, 'product_combo');

    const unsubscribe = onValue(productComboRef, (snapshot) => {
      const productComboData = snapshot.val();

      if (productComboData) {
        console.log('prodCom', productComboData);

        const updatedProductCombo = Object.keys(productComboData).map((key) => ({
          comboname: key,
          status: productComboData[key].status,
          start: productComboData[key].start,
          end: productComboData[key].end,
          items: productComboData[key].item,
        }));

        setProductCombo(updatedProductCombo);
      } else {
        alert('No product combo');
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
  console.log('product combo', productCombo);

  const onSubmit = async (data: ProductCombo2) => {
    // tambah status active ke deactive
    const startYear = start?.substring(0, 4);
    const startMonth = (start?.substring(4, 6) as any) - 1;
    const startDay = start?.substring(6, 8);

    const endYear = end?.substring(0, 4);
    const endMonth = (end?.substring(4, 6) as any) - 1;
    const endDay = end?.substring(6, 8);

    const startDate = new Date(Date.UTC(startYear as any, startMonth as any, startDay as any));
    const endDate = new Date(Date.UTC(endYear as any, endMonth as any, endDay as any));

    console.log(startDate.toISOString());
    console.log(endDate.toISOString());

    const formattedData: FormattedData = {
      [data.comboname]: {
        status: 'active',
        start: startDate.toISOString(),
        end: endDate.toISOString(),
        item: data.items,
      },
    };

    console.log('formattedData', formattedData);

    const newref = ref(db, `product_combo`);
    try {
      await update(newref, formattedData);
      console.log('Data saved successfully');
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };
  useEffect(() => {
    if (!start || !end) {
      const params = {
        from: formatParamDate(new Date()),
        till: formatParamDate(new Date()),
      };
      setSearchParams(serialiseSearchParams(params));
    }
  }, [start, end]);

  const handleDatesChanged = (dates: DateObject[]) => {
    const [start, end] = dates.map((e) => e?.toDate());
    if (start && end) {
      const params = {
        from: formatParamDate(start),
        till: formatParamDate(end),
      };
      setSearchParams(serialiseSearchParams(params));
    }
  };

  const handleStatusChange = async (comboname: string, status: string) => {
    let newStatus = '';
    if (status === 'active') {
      newStatus = 'deactive';
    } else {
      newStatus = 'active';
    }
    const confirmation = window.confirm(
      `Are you sure you want to change the status to ${newStatus}?`,
    );

    if (confirmation) {
      const newref = ref(db, `product_combo/${comboname}`);
      await update(newref, { status: newStatus });
    } else {
      console.log('Status change cancelled');
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ textAlign: 'center' }}>
          {/* <b className="smallTitle">Sale interval</b> */}
          <br></br>
          <b className="text">
            {' '}
            <DatePicker
              onOpen={() => setIsDateSelectorClosed(false)}
              onClose={() => setIsDateSelectorClosed(true)}
              range
              value={[startDate, endDate]}
              onChange={handleDatesChanged}
              style={{
                border: '1px solid var(--primaryColor)',
                height: '30px',
                width: '200px',
                padding: '2px 20px',
              }}
            />
          </b>
        </div>
        <Table hover responsive bordered>
          <thead style={{ borderWidth: 'thin' }}>
            <tr>
              <th>COMBO NAME</th>
              <th>SKU</th>
              <th>PRICE (RM)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan={fields.length + 1}>
                <input {...register('comboname')} />
              </td>
            </tr>
            {fields.map((field, index) => (
              <tr key={field.id}>
                <td>
                  <Controller
                    name={`items.${index}.sku`}
                    control={control}
                    defaultValue=""
                    render={({ field }) => <input {...field} />}
                  />
                </td>
                <td>
                  <Controller
                    name={`items.${index}.price`}
                    control={control}
                    defaultValue=""
                    render={({ field }) => <input {...field} />}
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan={3}>
                <button
                  type="button"
                  style={{
                    color: 'var(--secondaryColor)',
                    backgroundColor: 'var(--primaryColor)',
                    border: '1px solid var(--primaryColor)',
                    padding: '7px',
                    borderRadius: '10px',
                  }}
                  onClick={() => append({ sku: '', price: '' })}
                >
                  Add product
                </button>
              </td>
            </tr>
          </tbody>
        </Table>
        {/* <button
          style={{
            color: 'var(--secondaryColor)',
            backgroundColor: 'var(--primaryColor)',
            border: '1px solid var(--primaryColor)',
            padding: '7px',
            borderRadius: '10px',
            float: 'left',
          }}
          type="submit"
        >
          Add Combo
        </button> */}

        {/* <div
          style={{
            marginBottom: '100px',
          }}
        ></div> */}
        <button
          style={{
            color: 'var(--secondaryColor)',
            backgroundColor: 'var(--primaryColor)',
            border: '1px solid var(--primaryColor)',
            padding: '7px',
            borderRadius: '10px',
            float: 'right',
          }}
          type="submit"
        >
          Submit
        </button>
      </form>
      <br />
      <br />
      <br />
      <div>
        <Table hover responsive bordered>
          <thead>
            <tr>
              <th>Combo Name</th>
              <th>Sku</th>
              <th>Price (RM)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {productCombo !== undefined ? (
              productCombo.map((pc, index) => [
                <tr key={`${index}-name`}>
                  <td rowSpan={pc.items.length}>{pc.comboname}</td>
                  <td>{pc.items[0].sku}</td>
                  <td>{pc.items[0].price}</td>
                  <td
                    style={{ background: pc.status === 'active' ? 'rgb(187 240 219)' : '#f0bbbb' }}
                    rowSpan={pc.items.length}
                  >
                    <button
                      type="button"
                      // style={{
                      //   color: 'var(--secondaryColor)',
                      //   backgroundColor: 'var(--primaryColor)',
                      //   border: '1px solid var(--primaryColor)',
                      //   padding: '7px',
                      //   borderRadius: '10px',
                      // }}
                      onClick={() => handleStatusChange(pc.comboname, pc.status)}
                    >
                      {pc.status}
                    </button>
                  </td>
                </tr>,
                ...pc.items.slice(1).map((item, itemIndex) => (
                  <tr key={`${index}-${itemIndex}`}>
                    <td>{item.sku}</td>
                    <td>{item.price}</td>
                  </tr>
                )),
              ])
            ) : (
              <tr>
                <td colSpan={4}>No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default ComboProduct;
